import React from 'react';
import { Alert } from 'reactstrap';
import config from '../../config';

const NoDataAlertBox = (props) => {
    const { typeModelName, noDataText,noDataTextHeading, templateType,filterNoDatamage} = props;
    const modelName = typeModelName ? typeModelName.toLowerCase() : '';
    let imageUrlComplete = null;
    if(filterNoDatamage){
        
        imageUrlComplete = filterNoDatamage?`${config.assetsBasePath}${filterNoDatamage.path}`:null;
    }
    




    const noDataHeading = props.companyDetails && props.companyDetails.data &&  props.companyDetails.data.companySettings && props.companyDetails.data.companySettings.noDataHeading
    const noDataSubHeading = props.companyDetails && props.companyDetails.data && props.companyDetails.data.companySettings && props.companyDetails.data.companySettings.noDataSubHeading
    const noDataImage = props.companyDetails && props.companyDetails.data && props.companyDetails.data.companySettings && props.companyDetails.data.companySettings.noDataImage
    const noDataImageHeight = props.companyDetails && props.companyDetails.data && props.companyDetails.data.companySettings && props.companyDetails.data.companySettings.noDataImageHeight
    const noDataImageWidth = props.companyDetails && props.companyDetails.data && props.companyDetails.data.companySettings && props.companyDetails.data.companySettings.noDataImageWidth
    const isOnlyNoDataImage = props.companyDetails && props.companyDetails.data && props.companyDetails.data.companySettings && props.companyDetails.data.companySettings.isOnlyNoDataImage
     if(noDataImage){
         imageUrlComplete = noDataImage?`${config.assetsBasePath}${noDataImage}`:null;
    }

    if(isOnlyNoDataImage ){
      return  <Alert color='light' className='no-data-alert'>
        <div className='d-flex justify-content-center'>
            <div>
         {  imageUrlComplete &&   <img src={imageUrlComplete} height={noDataImageHeight ? parseInt(noDataImageHeight):''} width={noDataImageWidth ? parseInt(noDataImageWidth):''} alt="No Data Image" />}
                {/* <h5><i className="fa fa-exclamation-triangle mr-1" aria-hidden="true"></i> {noDataTextHeading? noDataTextHeading : noDataHeading ? noDataHeading:`No ${typeModelName}!`}</h5>
                <p>{noDataText ? noDataText : noDataSubHeading ? noDataSubHeading: `We weren't able to find any entries for ${modelName}`}</p> */}
            </div>
        </div>
    </Alert>
    }
    if(templateType && templateType.value === 'Template2'){
        return <Alert color='light' className='no-data-alert-2'>

                {  imageUrlComplete &&     <img src={imageUrlComplete} height={noDataImageHeight ? parseInt(noDataImageHeight):''} width={noDataImageWidth ? parseInt(noDataImageWidth):''}/>}
                  <h6 className='noDateHeadingText' style={{color:'#000',marginTop:10,fontWeight:'bold'}}> {noDataTextHeading?  noDataTextHeading : noDataHeading ? noDataHeading:`No ${typeModelName}!`}</h6>
                <p className='noDateSubHeadingText' style={{marginTop:10}} >{noDataText ? noDataText  : noDataSubHeading ? noDataSubHeading:`We weren't able to find any entries for ${modelName}`}</p>

    </Alert>
    }
    return <Alert color='light' className='no-data-alert'>
        <div className='d-flex justify-content-center'>
            <div>
          {  imageUrlComplete &&     <img src={imageUrlComplete} height={noDataImageHeight ? parseInt(noDataImageHeight):''} width={noDataImageWidth ? parseInt(noDataImageWidth):''}/>}
    
                <h5><i className="fa fa-exclamation-triangle mr-1" aria-hidden="true"></i> {noDataTextHeading? noDataTextHeading : noDataHeading ? noDataHeading:`No ${typeModelName}!`}</h5>
                <p>{noDataText ? noDataText : noDataSubHeading ? noDataSubHeading: `We weren't able to find any entries for ${modelName}`}</p>
            </div>
        </div>
    </Alert>
}

export default NoDataAlertBox;